/* tslint:disable */
/* eslint-disable */
/**
 * Wire API (development)
 * The API for the Clientwire messaging service.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@clientwire.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SetPasswordRequest
 */
export interface SetPasswordRequest {
    /**
     * The user’s email address.
     * @type {string}
     * @memberof SetPasswordRequest
     */
    email: string;
    /**
     * The new password.
     * @type {string}
     * @memberof SetPasswordRequest
     */
    password: string;
    /**
     * The plaintext token from the password reset link.
     * @type {string}
     * @memberof SetPasswordRequest
     */
    token: string;
}

/**
 * Check if a given object implements the SetPasswordRequest interface.
 */
export function instanceOfSetPasswordRequest(value: object): value is SetPasswordRequest {
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('password' in value) || value['password'] === undefined) return false;
    if (!('token' in value) || value['token'] === undefined) return false;
    return true;
}

export function SetPasswordRequestFromJSON(json: any): SetPasswordRequest {
    return SetPasswordRequestFromJSONTyped(json, false);
}

export function SetPasswordRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetPasswordRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
        'password': json['password'],
        'token': json['token'],
    };
}

export function SetPasswordRequestToJSON(json: any): SetPasswordRequest {
    return SetPasswordRequestToJSONTyped(json, false);
}

export function SetPasswordRequestToJSONTyped(value?: SetPasswordRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
        'password': value['password'],
        'token': value['token'],
    };
}

